const afterpaySelector = store => store.afterpay;

export default afterpaySelector;
